import api from '@/services/Http'

export const exportCurrentData = async () =>
  (await api()).get(`/sync/exports/current-data`, {
    responseType: 'blob',
  })
